import GoogleMaps from './initGoogleMaps';
import LocationMap from './initLocationMap';
import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

class Tjora {

    constructor() {

        this.menuToggleButton = document.querySelector('.toggle-menu');
        this.header = document.querySelector('.site-header')
        this.flickity = [];

        this.registerEvents();
        this.initFlickity();

        GoogleMaps();
        LocationMap();

    }

    toggleNavigation() {

        if ( this.header.classList.contains('open-navigation') ) {
            this.header.classList.remove('open-navigation');
            this.menuToggleButton.innerHTML = this.menuToggleButton.dataset.open;
        } else {
            this.header.classList.add('open-navigation');
            this.menuToggleButton.innerHTML = this.menuToggleButton.dataset.close;
        }
    }


    initFlickity() {

        // forEach method, could be shipped as part of an Object Literal/Module
        const forEach = function (array, callback, scope) {
          for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
          }
        };

        const carouselContainers = document.querySelectorAll('.flickity-container');
        if (carouselContainers.length > 0) {

            let carousels = [];
            forEach(carouselContainers, function (index, value) {
                carousels.push(value);
            });

            carousels.map(container => {
                imagesLoaded(container, () => {

                    let flickity = new Flickity(container, {
                        contain: true,
                        accessibility: true,
                        imagesLoaded: true,
                        percentPosition: false,
                        pageDots: false,
                        setGallerySize: false,
                        cellAlign: 'left',
                        groupCells: true,
                        arrowShape: { 
                          x0: 0,
                          x1: 50, y1: 50,
                          x2: 60, y2: 40,
                          x3: 20
                        }
                    });

                    this.flickity.push(flickity);

                })
            });
            
        }

    }


    registerEvents() {

        window.addEventListener('scroll', event => {

            let header = document.querySelector('.site-header'),
                offset = 0,
                scrollTop = window.pageYOffset;

            if ( scrollTop > offset ) {
                header.classList.add('solid');
            } else {
                header.classList.remove('solid');
            }

        });

        
        this.menuToggleButton.addEventListener('click', () => {this.toggleNavigation()});

    }



}
const site = new Tjora();


// WEBPACK FOOTER //
// ./src/js/app.js